export default __webpack_public_path__ + "abeddff23660acfde28968c04f25596a.png";